import { render, staticRenderFns } from "./reg_yes_no_question.vue?vue&type=template&id=31b31036&"
import script from "./reg_yes_no_question.vue?vue&type=script&lang=js&"
export * from "./reg_yes_no_question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports